import { localeMessages } from './locales';
function readPath(obj, key) {
    const value = key.split('.').reduce((current, part) => {
        if (current && typeof current === 'object' && part in current) {
            return current[part];
        }
        return undefined;
    }, obj);
    return typeof value === 'string' ? value : undefined;
}
function applyParams(template, params) {
    if (!params)
        return template;
    return template.replace(/\{(\w+)\}/g, (match, name) => {
        const value = params[name];
        return value === undefined ? match : String(value);
    });
}
export function translate(locale, key, params) {
    const template = readPath(localeMessages[locale], key) ??
        readPath(localeMessages.en, key) ??
        key;
    return applyParams(template, params);
}
